import React from 'react';
import { fetchInvestors } from 'actions/investors';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { date } from 'utils/date';
import { dollars } from 'utils/money';
import { Link } from 'react-router-dom';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import Divider from '@material-ui/core/Divider';
import { toggleNotification } from '/actions/commonActions';

import Form from 'components/Investors/Form';
import Investments from 'components/Investors/Investments';

const styles = theme => ({});

export class List extends React.Component {
  componentDidMount() {
    this.props.dispatch(fetchInvestors());
  }

  renderSpinner = () => {
    if (this.props.showSpinner) {
      return (
        <CircularProgress color='primary' thickness={7} style={{position: 'absolute', zIndex: '1', top: '50%', left: '50%'}}/>
      );
    }
  }

  renderInvestors = (investors) => {
    return (
      <Table data-test='investorsTable'>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Wechat</TableCell>
            <TableCell>Manager</TableCell>
            <TableCell>Bank Account</TableCell>
            <TableCell>Location Type</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { Object.values(investors).map(this.renderInvestor) }
        </TableBody>
      </Table>
    );
  }

  renderInvestor = (investor) => {
    const { classes } = this.props;

    return (
      <TableRow key={investor.id}>
        <TableCell>
          <Investments
            label={`${investor.firstName} ${investor.lastName}`}
            investorId={investor.id}
          />
        </TableCell>
        <TableCell>
          {investor.email}
        </TableCell>
        <TableCell>
          {investor.wechat}
        </TableCell>
        <TableCell>
          {investor.manager}
        </TableCell>
        <TableCell>
          {investor.bankAccount}
        </TableCell>
        <TableCell>
          {investor.locationType}
        </TableCell>
        <TableCell>
          <Form
            buttonStyles={classes.headerButton}
            buttonLabel='Edit'
            mode='update'
            investorId={investor.id}
            form={`updateInvestor${investor.id}`}
          />
        </TableCell>
      </TableRow>
    );
  }

  render = () => {
    const { investors, classes } = this.props;

    return (
      <div>
        <div style={{ display: 'flex' }}>
          <Typography variant='headline' className={classes.flex}>
            Investors
          </Typography>
          <Form
            buttonStyles={classes.headerButton}
            buttonLabel='Add Investor'
            mode='create'
            form='createInvestor'
          />
        </div>
        <Divider light />
        { investors ? this.renderInvestors(investors) : this.renderSpinner() }
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  const { investors } = state.investors;
  return { investors };
};

const styled = withStyles(styles)(List)
const connected = connect(mapStateToProps)(styled);
export default connected;



// WEBPACK FOOTER //
// ./src/components/Investors/List.js